var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mb-0 mx-2",attrs:{"color":_vm.banner.color,"dismissible":_vm.banner.dismissible},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(_vm.bannerComponents[_vm.banner.template] || _vm.bannerComponents.default,{tag:"component",attrs:{"data":_vm.banner.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }